module.exports = __webpack_public_path__ + "img/loading.0bb10241.gif";